import { TReactSetState } from "../../data/AppType";
import {
  GET_ALL_SYSTEM_CONFIGURATION,
  GET_SYSTEM_CONFIGURATION_BY_KEY,
  UPDATE_ALL_SYSTEM_CONFIGURATION,
} from "../../services/Endpoints";
import {
  IConfigPayload,
  IConfigValuePayload,
} from "../../services/system-configurations/SystemConfigurationsService";

import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import {
  decryptData,
  handleError,
  sweetAlertError,
  sweetAlertSuccess,
} from "../../utils/AppFunctions";

export const fetchSystemSettings = async (
  setSystemSettings: TReactSetState<IConfigPayload[]>,
  menuId: number,
) => {
  try {
    const systemSettings = await GET_ALL_SYSTEM_CONFIGURATION(menuId);

    if (systemSettings && systemSettings.code === DEFAULT_STATUS_CODE_SUCCESS) {
      const data = JSON.parse(decryptData(systemSettings.data));
      setSystemSettings(data);
    }
  } catch (e: any) {
    sweetAlertError({
      message: e?.systemSettings?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
    });
    handleError(e, "fetchSystemSettings");
  }
};

export const handleSubmitSystemConfiguration = async (
  values: IConfigValuePayload[],
) => {
  try {
    const resultBlogCategory = await UPDATE_ALL_SYSTEM_CONFIGURATION(values);

    if (
      resultBlogCategory &&
      resultBlogCategory.code === DEFAULT_STATUS_CODE_SUCCESS
    ) {
      sweetAlertSuccess({ message: resultBlogCategory.message });
    } else {
      sweetAlertError({
        message: resultBlogCategory?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
    }
  } catch (e: any) {
    sweetAlertError({
      message: e.resultBlogCategory?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
    });
    handleError(e, "handleSubmitSystemConfiguration");
  }
};

export const fetchSystemSettingsByConfigKey = async (configKey: string) => {
  try {
    const systemSettings = await GET_SYSTEM_CONFIGURATION_BY_KEY(configKey);

    if (systemSettings && systemSettings.code === DEFAULT_STATUS_CODE_SUCCESS) {
      const data = JSON.parse(decryptData(systemSettings.data));
      return data;
    } else {
      sweetAlertError({
        message: systemSettings.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
    }
  } catch (e: any) {
    sweetAlertError({
      message: e?.systemSettings?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
    });
    handleError(e, "fetchSystemSettingsByConfigKey");
  }
};
